import jwt from 'jsonwebtoken';
import get from 'lodash/get';

export const getRole = (token) => {
  const decoded = jwt.decode(token);
  return get(decoded, 'role', null);
};
